import { isNil } from 'lodash';
import { AssignmentEntry } from '../entries';
import { Assignment } from './Assignment';
import { AssignmentType } from './AssignmentComplete';

export interface AssignmentWithEntry<T extends AssignmentType = AssignmentType> {
  assignment: Assignment<T>;
  entry: AssignmentEntry;
}

export namespace AssignmentWithEntry {
  export function from(
    assignment: Assignment | undefined,
    entry: AssignmentEntry | undefined
  ): AssignmentWithEntry | undefined {
    if (isNil(assignment) || isNil(entry)) {
      return undefined;
    }
    return { assignment, entry };
  }
}
